function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.75 7.09a.6.6 0 010-.85l5.12-5.12a1.6 1.6 0 012.263 0l5.12 5.119a.6.6 0 01-.849.848l-5.12-5.12a.4.4 0 00-.565 0L1.598 7.09a.6.6 0 01-.849 0z",
  fill: "#333"
});

function SvgUpChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDE0IDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC43NDkxNjIgNy4wODkyNEMwLjUxNDg0NyA2Ljg1NDkyIDAuNTE0ODQ3IDYuNDc1MDIgMC43NDkxNjEgNi4yNDA3MUw1Ljg3MDQ4IDEuMTE5MzlDNi40OTUzMiAwLjQ5NDU0NyA3LjUwODM5IDAuNDk0NTQ3IDguMTMzMjMgMS4xMTkzOUwxMy4yNTI3IDYuMjM4ODRDMTMuNDg3IDYuNDczMTUgMTMuNDg3IDYuODUzMDUgMTMuMjUyNyA3LjA4NzM3QzEzLjAxODQgNy4zMjE2OCAxMi42Mzg1IDcuMzIxNjggMTIuNDA0MiA3LjA4NzM3TDcuMjg0NyAxLjk2NzkxQzcuMTI4NDkgMS44MTE3MSA2Ljg3NTIyIDEuODExNyA2LjcxOTAxIDEuOTY3OTFMMS41OTc2OSA3LjA4OTI0QzEuMzYzMzggNy4zMjM1NSAwLjk4MzQ3NiA3LjMyMzU1IDAuNzQ5MTYyIDcuMDg5MjRaIiBmaWxsPSIjMzMzMzMzIi8+Cjwvc3ZnPgo=";
export { SvgUpChevron as ReactComponent };